import React from 'react';
import cn from 'classnames';

import Icon from 'brandComponents/Icon';

import {IStoreSearchInputProps} from './IStoreSearchInput';

import styles from './StoreSearchInput.module.scss';

const StoreSearchInput: React.FC<IStoreSearchInputProps> = ({
	searchInputRef,
	inputPlaceholder,
}) => {
	const hasLabel = inputPlaceholder.length > 40;

	return (
		<div className={cn('store-search-input', styles['store-search-input'])}>
			<label className={cn(
				styles['store-search-input__label'],
				{'show-label': hasLabel}
			)}>
				{inputPlaceholder}
			</label>
			<Icon name="localization" height={20} width={20} />
			<input
				className={cn('store-search-input__input',
					styles['store-search-input__input'],
					{'hide-placeholder': hasLabel}
				)}
				name="store-locator-input"
				type="text"
				placeholder={inputPlaceholder}
				ref={searchInputRef}
			/>
		</div>
	);
};
export default StoreSearchInput;
